import './DraggableTrainFarePriority.css'

import { Reorder } from 'framer-motion'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { useState } from 'react'

import { alert } from '../../Pages/CommunityPanel/Functions'
import { cap } from '../../State'
import { translations } from '../../translations'
const language = cap.language.state || 'IT'
const t = translations[language]

const companyOptions = [
  { label: 'Trenitalia', value: 'TIT' },
  { label: 'Italo', value: 'NTV' }
]

export const DraggableTrainFarePriority = ({ data: items = [], onUpdate, fareCategory }) => {
  const [newFareType, setNewFareType] = useState('')
  const [newCompany, setNewCompany] = useState('TIT')

  const addNewItem = () => {
    if (!newFareType.trim()) return

    // Check for duplicates
    const isDuplicate = items.some(
      (item) =>
        item.tipologiaTariffa.toLowerCase() === newFareType.toLowerCase() &&
        item.compagnia === newCompany
    )

    if (isDuplicate) {
      alert('error', t.duplicato, t.combTariffaCompagniaDuplicata)
      return
    }

    const newItem = {
      id: `fare_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      tipologiaTariffa: newFareType.trim(),
      compagnia: newCompany
    }

    onUpdate([...items, newItem])
    setNewFareType('')
    setNewCompany('TIT')
  }

  const removeItem = (itemId) => {
    onUpdate(items.filter((item) => item.id !== itemId))
  }

  const updateItem = (itemId, field, value) => {
    const updatedItems = items.map((item) => {
      if (item.id === itemId) {
        return { ...item, [field]: value }
      }
      return item
    })
    onUpdate(updatedItems)
  }

  return (
    <div className="train-fare-priority-container">
      <div className="train-fare-priority-header">
        {fareCategory === 'rimborsabile' ? t.tariffeRimborsabili : t.tariffeNonRimborsabili}
      </div>

      {/* Add new item section */}
      <div className="train-fare-priority-add-section">
        <InputText
          value={newFareType}
          onChange={(e) => setNewFareType(e.target.value)}
          placeholder={t.tipologiaTariffa}
          className="train-fare-priority-input"
        />

        <Dropdown
          value={newCompany}
          onChange={(e) => setNewCompany(e.value)}
          options={companyOptions}
          optionLabel="label"
          optionValue="value"
          placeholder={t.compagniaTreno}
          className="train-fare-priority-dropdown"
        />

        <button
          className="train-fare-priority-add-btn"
          onClick={addNewItem}
          disabled={!newFareType.trim()}
        >
          <i className="fa-duotone fa-plus" />
        </button>
      </div>

      <Reorder.Group
        className="train-fare-priority-list"
        axis="y"
        values={items}
        onReorder={onUpdate}
      >
        {items.map((item, index) => (
          <Reorder.Item key={item.id} value={item} className="train-fare-priority-item">
            <div className="train-fare-priority-number">{index + 1}</div>

            <InputText
              value={item.tipologiaTariffa}
              onChange={(e) => updateItem(item.id, 'tipologiaTariffa', e.target.value)}
              placeholder={t.tipologiaTariffa}
              className="train-fare-priority-item-input"
            />

            <Dropdown
              value={item.compagnia}
              onChange={(e) => updateItem(item.id, 'compagnia', e.value)}
              options={companyOptions}
              optionLabel="label"
              optionValue="value"
              placeholder={t.compagniaTreno}
              className="train-fare-priority-item-dropdown"
            />

            <button className="train-fare-priority-delete-btn" onClick={() => removeItem(item.id)}>
              <i className="fa-duotone fa-trash" />
            </button>
          </Reorder.Item>
        ))}
      </Reorder.Group>
    </div>
  )
}
